import { render, staticRenderFns } from "./MainInterface.vue?vue&type=template&id=45f88825&scoped=true&"
import script from "./MainInterface.vue?vue&type=script&lang=js&"
export * from "./MainInterface.vue?vue&type=script&lang=js&"
import style0 from "./MainInterface.vue?vue&type=style&index=0&id=45f88825&scoped=true&lang=scss&"
import style1 from "./MainInterface.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f88825",
  null
  
)

export default component.exports